// @flow

import * as React from 'react';
import { toast } from 'react-toastify';
import deepEqual from 'deep-equal';
import { ClassNames } from '@emotion/core';

import notificationsConfigFactory from '../config/notifications';
import messages from '../config/messages';

const {logger} = require("../utils");

type Props = {
  moduleName: 'order' | 'transmitOrder' | 'removeOrder',
  namespace?: 'det' | '',
  collection?: any,
  anouncements?: Array<string>,
  isMobile: Boolean,
};

class ActionAlerts extends React.Component<Props & { config: any }> {
  toastId = null;
  activeAlerts: Array<string> = [];
  pastAnouncements: Array<string> = [];
  supportedTypes = ['update', 'remove', 'outofstock'];

  shouldComponentUpdate(nextProps: Props) {
    if (
      (nextProps.collection &&
        !deepEqual(nextProps.collection, this.props.collection)) ||
      (nextProps.anouncements &&
        !deepEqual(nextProps.anouncements, this.props.anouncements))
    ) {
      return true;
    }

    return false;
  }

  generateAlerts = (props: Props) => {
    const { moduleName, namespace, collection, anouncements } = props;

    let alerts = [];
    if (collection && Array.isArray(collection)) {
      alerts = collection
        .filter(
          i =>
            i.maxItemQty &&
            this.supportedTypes.includes(i.maxItemQty.ActionPerOrderType),
        )
        .map(i => i.maxItemQty.ActionPerOrderType);
    }

    if (anouncements && Array.isArray(anouncements)) {
      /**
       * we'll only include new anouncements (to avoid showing the
       * same alert multiple times)
       */
      alerts = [
        ...alerts,
        ...anouncements.filter(i => !this.pastAnouncements.includes(i)),
      ];
    }

    alerts.forEach(type => {
      if (this.pastAnouncements.includes(type)) {
        return;
      }

      const alertId = namespace
        ? `${moduleName}${namespace}${type}`
        : `${moduleName}${type}`;

      if (this.activeAlerts.includes(alertId)) {
        return;
      }

      this.activeAlerts.push(alertId);

      if (
        !messages[moduleName] ||
        (namespace && !messages[moduleName][namespace]) ||
        (namespace
          ? !messages[moduleName][namespace][type]
          : !messages[moduleName][type])
      ) {
        if (namespace) {
          logger.warn(
            `messages[${moduleName}][${namespace}][${type}] is not defined`,
          );
        } else {
          logger.warn(`messages[${moduleName}][${type}] is not defined`);
        }

        return;
      }

      const m = namespace
        ? messages[moduleName][namespace][type]
        : messages[moduleName][type];

      /**
       * this is to avoid showing the user the same modal over and
       * over. It basically means that once closed, we won't show it
       * until this component gets unmounted (which only happens on
       * pageunload)
       */
      this.pastAnouncements.push(type);

      toast(m, {
        ...(this.props.config[type] || this.props.config.defaultStyle),
        onClose: () => {
          this.activeAlerts = this.activeAlerts.filter(i => i !== alertId);
        },
        position: this.props.isMobile ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_RIGHT,
      });
    });
  };

  componentDidMount() {
    this.generateAlerts(this.props);
  }

  componentDidUpdate() {
    this.generateAlerts(this.props);
  }

  render() {
    return null;
  }
}

export default function(props: Props) {
  return (
    <ClassNames>
      {({ css }) => {
        return (
          <ActionAlerts {...props} config={notificationsConfigFactory(css)} />
        );
      }}
    </ClassNames>
  );
}
